import React from 'react';
import * as R from 'ramda';
import { Box, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const DISTRIBUTION_WIDTH = 100;

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    width: DISTRIBUTION_WIDTH,
    minWidth: DISTRIBUTION_WIDTH,
    maxWidth: DISTRIBUTION_WIDTH,
    height: 16,
  },
  scoreBox: {
    height: '100%',
    borderRadius: 1,
    minWidth: 8,
    flexBasis: 0,
  },
  excellent: {
    backgroundColor: '#4caf50',
  },
  good: {
    backgroundColor: '#8bc34a',
  },
  average: {
    backgroundColor: '#ffeb3b',
  },
  poor: {
    backgroundColor: '#ff9800',
  },
  failed: {
    backgroundColor: '#f44336',
  },
  pending: {
    backgroundColor: '#e0e0e0',
  },
});

const getScoreCategory = (score) => {
  if (score === undefined || score === null) return 'pending';
  if (score >= 90) return 'excellent';
  if (score >= 75) return 'good';
  if (score >= 60) return 'average';
  if (score >= 40) return 'poor';
  return 'failed';
};

const getTooltipText = (category, count) => {
  const labels = {
    excellent: 'Excellent (90-100%)',
    good: 'Good (75-89%)',
    average: 'Average (60-74%)',
    poor: 'Poor (40-59%)',
    failed: 'Failed (0-39%)',
    pending: 'Pending',
  };
  return `${labels[category]}: ${count}`;
};

const QuizScoreDistributionField = ({ record, source }) => {
  const classes = useStyles();
  const submissions = R.propOr([], source)(record);

  const categoryCount = R.pipe(
    R.groupBy((submission) => getScoreCategory(submission.globalScore)),
    R.map(R.length)
  )(submissions);

  const pendingCount = R.length(R.propOr([], 'pending')(record));
  const allCounts = { ...categoryCount, pending: pendingCount };

  const categories = [
    'excellent',
    'good',
    'average',
    'poor',
    'failed',
    'pending',
  ];

  return (
    <Box className={classes.root}>
      {categories.map((category) => {
        const count = R.propOr(0, category, allCounts);
        return count > 0 ? (
          <Tooltip key={category} title={getTooltipText(category, count)} arrow>
            <Box
              className={`${classes.scoreBox} ${classes[category]}`}
              style={{ flexGrow: count }}
            />
          </Tooltip>
        ) : null;
      })}
    </Box>
  );
};

export default QuizScoreDistributionField;
